/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import useGetBrandList from "../../utils/CustomHooks/useBrandList";
import { isValidArray } from "../../utils/Functions/Filter";
import { useNavigate, useParams } from "react-router-dom";
import NewLoader from "../../Components/Loader";
import BrandPage from "./BrandPage";

const ExploreBrand = () => {
  const { brandList, getBrandList } = useGetBrandList();
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (id) {
      getBrandList(
        {
          brand_domain: id,
          // to update defaults inside the hook
          active: null,
          is_test_brand: null,
          is_product_sync_completed: null,
          is_shopify_sync_completed: null,
          is_product_approved: null,
        },
        () => {},
        () => {
          navigate("/", { replace: true });
        }
      );
    }
  }, [id]);
  const brand = useMemo(
    () =>
      id &&
      (isValidArray(brandList)
        ? brandList.find((x) => x.brand_domain === id) || {}
        : {}),
    [brandList, id]
  );
  if (!brand.brand_id) return <NewLoader />;

  return <BrandPage brand={brand} />;
};

export default ExploreBrand;
